
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/shared/cta-section.kpa`,
      template: `<section class="cta-section box-shadow" 
        style="background-image: 
            linear-gradient(-15deg, rgba(44, 65, 67, .4) 40%, rgba(44, 65, 67, .9) 70%), 
            linear-gradient(15deg, rgba(44, 65, 67, .4) 40%, rgba(44, 65, 67, .8) 80%), 
            url('{{backgroundImage}}');" 
        aria-label="CTA Section"
    >
        <div class="wrapper">
            <div class="cta-area">
                <div class="cta-card">
                    <span class="content">
                        <span if="subheadline" class="subh1" id="cta-subheadline">{{subheadline}}</span>
                        <h1 if="headline" id="cta-headline" class="text-shadow">{{headline}}</h1>
                        <p if="text" class="text-shadow">{{text}}</p>
                    </span>
                    <span class="buttons">
                        <button if="buttonText" class="btn-cta box-shadow btn1" aria-label="Call to action">{{buttonText}}</button>
                        <button if="buttonText2" class="btn-cta box-shadow btn1" aria-label="Call to action">{{buttonText2}}</button>
                    </span>
                </div>
            </div>
        </div>
    </section>`,
      style: `cta-section .cta-section {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
cta-section .cta-section .wrapper {
  max-width: 1568px;
  padding: 64px;
}
cta-section .cta-section .wrapper .cta-area {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: 24px;
}
cta-section .cta-section .wrapper .cta-area .cta-card {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: stretch;
  gap: 16px;
  max-width: 840px;
}
cta-section .cta-section .wrapper .cta-area .cta-card .content {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: stretch;
  gap: 16px;
}
cta-section .cta-section .wrapper .cta-area .cta-card .content .subh1 {
  font-size: 1.2rem;
  margin-bottom: 0;
  color: #ffffff;
  display: inline-block;
  width: auto;
  padding: 4px 12px;
  border-radius: 32px;
  font-weight: 700;
  align-self: center;
}
cta-section .cta-section .wrapper .cta-area .cta-card .content h1, cta-section .cta-section .wrapper .cta-area .cta-card .content p {
  margin: 0;
  padding: 0;
  color: #eeeeee;
  text-align: center;
}
cta-section .cta-section .wrapper .cta-area .cta-card .content h1 {
  font-size: 3rem;
}
cta-section .cta-section .wrapper .cta-area .cta-card .content p {
  font-size: 1.2rem;
  color: #eeeeee;
}
cta-section .cta-section .wrapper .cta-area .cta-card .content p strong {
  font-size: 1.9rem;
  color: #62be6a;
}
cta-section .cta-section .wrapper .cta-area .cta-card .buttons {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  padding-top: 14px;
  gap: 24px;
}
cta-section .cta-section .wrapper .cta-area .cta-card .buttons .btn-cta {
  height: 64px;
  font-weight: 700;
  text-transform: uppercase;
  border-radius: 64px;
  font-size: 1rem;
}
cta-section .cta-section .wrapper .cta-area .cta-card .buttons .btn2 {
  background-color: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;
}
cta-section .cta-section .wrapper .cta-area .cta-card .buttons .btn2:hover {
  background-color: #4a9e51;
}
cta-section .cta-section .wrapper .cta-area .cta-card span:empty {
  display: none;
}
@media (max-width: 576px) {
  cta-section .cta-section .wrapper .cta-area .cta-card .content h1 {
    font-size: 2.1rem;
    color: #ffffff;
    display: inline-block;
  }
  cta-section .cta-section .wrapper .cta-area .cta-card .content p {
    font-size: 1.2rem;
    max-width: 600px;
    color: #eeeeee;
    display: block;
  }
  cta-section .cta-section .wrapper .cta-area .cta-card .content p strong {
    font-size: 1.5rem;
  }
}
@media (max-width: 400px) {
  cta-section .cta-section .wrapper .cta-area .cta-card .content h1 {
    font-size: 1.7rem;
  }
  cta-section .cta-section .wrapper .cta-area .cta-card .content p {
    font-size: 1rem;
  }
  cta-section .cta-section .wrapper .cta-area .cta-card .content strong {
    font-size: 1.3rem;
    color: red;
  }
  cta-section .cta-section .wrapper .cta-area .cta-card .buttons .btn1, cta-section .cta-section .wrapper .cta-area .cta-card .buttons .btn2 {
    font-size: 0.9rem;
  }
}
@media (max-width: 330px) {
  cta-section .cta-section .wrapper .cta-area .cta-card {
    padding-left: 16px;
  }
}
@media (max-width: 992px) {
  cta-section .cta-section .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    props: {
        backgroundImage: {
            type: 'string',
            required: true,
        },
        subheadline: {
            type: String,
            default: "",
        },
        headline: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            default: "",
        },
        buttonText: {
            type: String,
            default: "",
        },
        buttonLink: {
            type: String,
            default: "",
        },
        buttonText2: {
            type: String,
            default: "",
        },
        buttonLink2: {
            type: String,
            default: "",
        },
    },
    events: [
        ['click', '.cta-section button:first-of-type', function (event) {
                event.preventDefault();
                if (this.buttonLink)
                    router.navigate(this.buttonLink);
            }],
        ['click', '.cta-section button:last-of-type', function (event) {
                event.preventDefault();
                if (this.buttonLink2)
                    router.navigate(this.buttonLink2);
            }],
    ]
};
 })()`
    };
  